<template>
  <div class="sc-message--text" :style="colors[message.direction || 'received']">
    <p class="sc-message--text-content" ref="messageText">{{messageText}}</p>
  </div>
</template>

<script>
import Autolinker from 'autolinker'

export default {
  name: 'TextMessage',
  inject: {
    colors: {
      type: Object
    }
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.autoLink();
  },
  computed: {
    messageText() {
      return this.message.data.text.replace( /\n/g, '<br />' );
    }
  },
  methods: {
    autoLink () {
      // Create a links for Urls for all received messages
      if (this.message.direction === "received") {
        this.$nextTick(() => {
          const text = this.$refs.messageText.innerText;
          this.$refs.messageText.innerHTML = Autolinker.link(text, {
            className: 'chatLink',
            truncate: { length: 50, location: 'smart' }
          });
        })
      }
    }
  }
}
</script>

<style scoped>
a.chatLink {
  color: inherit !important;
}
p.sc-message--text-content {
  margin: 0 !important;
}
</style>
